import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { filter, take } from 'rxjs/operators'
import {
  SelectRentalDialogComponent,
  SelectRentalDialogConfig,
} from '@tv3/shared/dialogs/select-rental-dialog/select-rental-dialog.component'
import { DialogService, isSomething, Rental } from '@tokeet-frontend/tv3-platform'
import { MatDialogConfig } from '@angular/material/dialog'

@Injectable({
  providedIn: SharedModule,
})
export class SelectRentalDialogService {
  constructor(private dialog: DialogService) {}

  public open(config?: SelectRentalDialogConfig) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: { config },
      panelClass: ['fixed-modal'],
    }

    return this.dialog
      .openFixedDialog<SelectRentalDialogComponent, Rental | Rental[]>(SelectRentalDialogComponent, defaultConfig)
      .afterClosed()
      .pipe(
        filter((res) => (config?.required ? isSomething(res) : true)),
        take(1)
      )
  }
}
